/**
* @file 提示框组件
* @description 提示框组件，用于显示详细信息表格
* @author zhouyang
* @date 2026-06-09
* @version 1.0.0
* @copyright 脱手网物联科技(南京)有限公司
*/
<template>
	<div>
		<el-button size="small" style="color: #ffffff; background-color: #ff8a5c; border-color: #ff8a5c;"
			@click.stop="handleClick">疑似关联</el-button>
		<el-tooltip class="box-item" effect="dark" placement="top-start" trigger="manual" :visible="visible"
			:popper-class="'tooltip-gray'">
			<template #content>
				<el-table :data="tableData" border style="width: 800px" size="small" v-loading="loading"
					:row-style="addStyle" :cell-style="cellStyle" @row-click="rowClick" :height="350"
					:row-class-name="tableRowClassName" @row-dblclick="rowDblclick"
					:header-cell-style="{ 'background-color': '#e5e5e5' }">
					<el-table-column prop="img" label="实图" width="80" header-align="center" show-overflow-tooltip>
						<template #default="scope">
							<div v-if="!scope.row || scope.row.img.length <= 0">
								<div @click="$emit('preview', scope.row, scope.row.img)">
									<el-image style="" :src="require('@/assets/img/error_img.png')" loading="lazy" />
								</div>
							</div>
							<div v-else>
								<div @click="$emit('preview', scope.row, scope.row.img)">
									<el-image :src="scope.row.img[0]" loading="lazy" />
								</div>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="" label="" width="20" />
					<el-table-column prop="stock_type_txt" label="货物状态" header-align="center" width="170"
						show-overflow-tooltip>
						<template #default="scope">
							<div class="stock_type_txt_button">
								<span v-for="item in scope.row.stock_type_txt_list">
									<el-button class="A" size="small" text bg
										v-if="item == '二手' || item == '过保' || item == '包附破损'" style="">{{ item
										}}</el-button>
									<el-button class="C" size="small" text bg v-else color="#ff8a5c">{{
										item }}</el-button>
								</span>
							</div>
							<!-- <el-button-group class="ml-4">
										    <el-button size="small"/>
										    <el-button size="small" />
										    <el-button size="small" />
										  </el-button-group> -->
						</template>
					</el-table-column>
					<el-table-column prop="" label="" width="20" />
					<el-table-column prop="brand_name" label="产品信息" show-overflow-tooltip>
						<template #default="scope">
							<div class="product-info">
								<div class="product-tags">
									<el-tag type="danger" v-if="scope.row.issus == 1" size="small">疑似关联</el-tag>
								</div>
								<div class="brand-name" v-if="scope.row.brand_name">{{ scope.row.brand_name }}</div>
								<div class="product-name" v-if="scope.row.name">{{ scope.row.name }}</div>
								<div class="product-details" v-if="scope.row.model">
									<span class="detail-label">型号</span><span class="label-colon">：</span>
									<span class="detail-value">{{ scope.row.model }}</span>
								</div>
								<div class="product-details" v-if="scope.row.order_no">
									<span class="detail-label">订货号</span><span class="label-colon">：</span>
									<span class="detail-value">{{ scope.row.order_no }}</span>
								</div>
								<div class="product-details" v-if="scope.row.unit">
									<span class="detail-label">单位</span><span class="label-colon">：</span>
									<span class="detail-value">{{ scope.row.unit }}</span>
								</div>
								<div class="product-user-type" v-if="scope.row.type_name">
									<span class="detail-label">用户类型</span><span class="label-colon">：</span>
									<span class="detail-value">{{ scope.row.type_name }}</span>
								</div>
								<span
									v-if="!scope.row.brand_name && !scope.row.name && !scope.row.model && !scope.row.order_no">-</span>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="" label="" width="20" />
					<el-table-column prop="tsw_price" align="center" header-align="center" label="单价" width="100"
						show-overflow-tooltip>
						<template #default="scope">
							<el-tooltip placement="top">
								<template #content>
									<p>此信息由用户提供</p>
									<p>列表价格：{{ scope.row.price }}</p>
									<p>折扣：{{ scope.row.tsw_discount }}</p>
								</template>
								<span class="price-value">{{ scope.row.tsw_price }}</span>
							</el-tooltip>
						</template>
					</el-table-column>
					<el-table-column prop="" label="" width="20" />
					<el-table-column prop="sur_num" label="库存" width="80" align="center" header-align="center"
						show-overflow-tooltip>
						<template #default="scope">
							<div class="stock-cell">
								<span class="stock-value">{{ scope.row.sur_num }}</span>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="" label="" width="20" />
					<el-table-column prop="" label="聊天" width="60" align="center" header-align="center"
						show-overflow-tooltip>
						<template #default="scope">
							<span>
								<el-icon size="18" @click="chat_click(scope.row.id)"
									style="color:var(--el-color-primary); margin-top: 4px;">
									<ChatDotSquare />
								</el-icon>
							</span>
						</template>
					</el-table-column>
					<el-table-column prop="" label="详情" width="80" align="center" header-align="center"
						show-overflow-tooltip>
						<template #default="scope">
							<el-button size="small" type="primary" link @click="viewDetail(scope.row)">查看</el-button>
						</template>
					</el-table-column>
				</el-table>
			</template>
			<div style="width: 1px; height: 1px;"></div>
		</el-tooltip>
	</div>
</template>

<script>
import '../../assets/search/index.css'
import { ChatDotSquare } from '@element-plus/icons-vue'

let activeTooltipId = null
const listeners = new Set()

function setActiveTooltip(id) {
	activeTooltipId = id
	listeners.forEach(fn => fn(id))
}

export default {
	name: 'TooltipComponent',
	props: {
		id: {
			type: [String, Number],
			default: ''
		}
	},
	data() {
		return {
			tableData: [],
			loading: false,
			index: [],
			user_id: '',
			visible: false,
			unsubscribe: null
		}
	},
	mounted() {
		document.addEventListener('click', this.handleOutsideClick)
		this.unsubscribe = (newId) => {
			if (String(newId) !== String(this.id)) {
				this.visible = false
			}
		}
		listeners.add(this.unsubscribe)
		const container = document.querySelector('.product-page-container')
		if (container) {
			container.addEventListener('scroll', this.handleScroll)
		}
	},
	beforeUnmount() {
		document.removeEventListener('click', this.handleOutsideClick)
		listeners.delete(this.unsubscribe)
		const container = document.querySelector('.product-page-container')
		if (container) {
			container.removeEventListener('scroll', this.handleScroll)
		}
	},
	created() {
		this.user_id = localStorage.getItem('user_id');

	},

	methods: {
		/**
		 * 点击聊天图标
		 * @param {String|Number} id - 用户ID
		 */
		chat_click(id) {
			this.$emit('chat-click', id)
		},
		/**
		 * 点击按钮获取数据
		 */
		async handleClick() {
			setActiveTooltip(this.id)
			this.visible = true
			this.loading = true
			try {
				const res = await this.$axios.post('/api/yunsys.Storage/getsuspect', { id: this.id })
				const d = res.data
				if (d.code === 0) {
					console.log(d)
					var obj = this
					d.data.forEach(item => {
						item.stock_type_txt_list = item.stock_type_txt.split("、");
						item.num_input = 1;
						if (obj.user_id) {
							item.real_money = obj.$bn.multiply(item.sur_num, item.real_price, 2);
							item.real_price = obj.$bn.multiply(item.real_price, 1, 2);
							item.tsw_price = obj.$bn.multiply(item.tsw_price, 1, 2);
							item.tsw_discount = obj.$bn.divide(item.tsw_price, item.price, 3);
						} else {
							item.real_money = '*';
							item.real_price = '*';
							item.discount_calculate = '*';
							item.sur_num = '*';
						}
					});
					this.tableData = d.data
					console.log(this.tableData)
				}
			} catch (error) {
				console.error('获取数据失败', error)
			} finally {
				this.loading = false
			}
		},
		/**
		 * 滚动关闭
		 */
		handleScroll() {
			this.visible = false
		},
		/**
		 * 点击外部关闭
		 * @param {Event} e - 点击事件
		 */
		handleOutsideClick(e) {
			const isOutside = !this.$el.contains(e.target)
			const popper = document.querySelector('.tooltip-gray')
			const isPopper = popper && popper.contains(e.target)
			if (isOutside && !isPopper) {
				this.visible = false
			}
		},
		/**
		 * 数量变化
		 * @param {Number} val - 数量值
		 */
		handleChange(val) {
			console.log(val)
		},
		/**
		 * 单击行
		 * @param {Object} row - 行数据
		 * @param {Object} column - 列数据
		 * @param {Event} e - 事件对象
		 */
		rowClick(row, column, e) {
			this.index = [parseInt(row.index)]
		},
		/**
		 * 双击行
		 * @param {Object} row - 行数据
		 */
		rowDblclick(row) {
			console.log('双击行', row)
		},
		/**
		 * 行类名
		 * @param {Object} row - 行数据
		 * @returns {string} 类名
		 */
		tableRowClassName({ row, rowIndex }) {
			if (!row) return ''
			row.index = rowIndex
			if (this.index.indexOf(rowIndex) > -1) {
				return 'selected'
			}
			return ''
		},
		/**
		 * 行样式
		 * @param {Object} row - 行数据
		 * @returns {Object} 样式对象
		 */
		addStyle({ row, rowIndex }) {
			if (this.index.indexOf(rowIndex) > -1) {
				return { 'border': '1px solid #ff8a5c !important' }
			}
		},
		/**
		 * 单元格样式
		 * @param {Object} column - 列数据
		 * @returns {Object} 样式对象
		 */
		cellStyle({ columnIndex }) {
			if (columnIndex === 0) {
				return { 'background-color': '#fff !important' }
			}
		},
		/**
		 * 查看详情
		 * @param {Object} row - 行数据
		 */
		viewDetail(row) {
			const url = this.$router.resolve({ path: '/product', query: { id: row.id } }).href
			window.open(url, '_blank')
		}
	}
}
</script>

<style>
.el-popper.tooltip-gray {
	background-color: #f5f5f5 !important;
	border: 1px solid #dcdfe6 !important;
	color: #606266 !important;
}

.el-popper.tooltip-gray .popper__arrow::before {
	background-color: #f5f5f5 !important;
	border: 1px solid #dcdfe6 !important;
}

.el-popper.tooltip-gray>.el-popper__arrow::before {
	background-color: #f5f5f5 !important;
	border: 1px solid #dcdfe6 !important;
}

.el-popper.tooltip-gray .el-popper__arrow::before {
	border-bottom-color: #fff !important;
	border-left-color: #fff !important;
}

.el-table--border .el-table__cell {
	border-right: aliceblue;
}

.el-table--border .el-table__cell {
	border-right: none !important;
}

.el-table th.el-table__cell.is-leaf {
	border-right: none !important;
}
.table-center-label{
    border-right: var(--el-table-border) !important;
}
.el-popper.tooltip-gray {

	padding: 0.5rem !important;

}

.stock_type_txt_button .el-button {
	margin-right: 5px;
	font-size: 0.70rem !important;
	padding: 0.2525rem 0.5875rem;
}

.stock_type_txt_button .A {
	color: #ff8a5c !important;
	background-color: rgb(255, 240, 228) !important;
}

.stock_type_txt_button .B {
	color: red !important;
	background-color: rgb(255, 243, 245) !important;
}

.stock_type_txt_button .C {
	color: rgb(75, 212, 205) !important;
	background-color: rgb(223, 255, 251) !important;
}

.el-image {
	border-radius: 6px;
	height: 60px;
	width: 60px;
	display: inline-block;
	display: flex;
	border: 1px solid #eee;
}
</style>
